import axiosInstance from './axiosInstance';

const createLeague = async (leagueData) => {
	const response = await axiosInstance.post('/leagues', leagueData,
		{
			headers: {
				'Content-Type': 'application/json',
			},
		});
	return response.data;
};

const getAllLeagues = async () => {
	const response = await axiosInstance.get('/leagues');
	return response.data;
};

const getPublicLeagues = async () => {
	const response = await axiosInstance.get('/leagues/publicLeagues');
	return response.data;
};

const deleteLeague = async (id) => {
	await axiosInstance.delete(`/leagues/${id}`);
};

const updateLeague = async (id, data) => {
	const response = await axiosInstance.put(`/leagues/${id}`, data, {
		headers: { 'Content-Type': 'application/json' },
	});
	return response.data;
};

const getMyLeagues = async () => {
	const response = await axiosInstance.get(`/leagues/myLeagues`);
	return response.data;
};

const getLeagueById = async (id) => {
	const response = await axiosInstance.get(`/leagues/${id}`);
	return response.data;
};

const getLeagueRankings = async (leagueId, date = null) => {
    const params = {};
    if (date) {
        // Bezpečnější konverze na YYYY-MM-DD s ohledem na časovou zónu
        // (prostý toISOString() by mohl vrátit včerejší den, pokud je večer UTC)
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - (offset * 60 * 1000));
        params.date = localDate.toISOString().split('T')[0];
        // Posíláme i IANA zónu prohlížeče, aby backend definoval hranice hracího dne
        // ve stejné zóně, podle které frontend zápasy do dnů grupuje (jinak by se body
        // půlnočních zápasů počítaly do sousedního dne). Backend má fallback, kdyby
        // zóna chyběla nebo byla neplatná.
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (tz) {
            params.zone = tz;
        }
    }

    const response = await axiosInstance.get(`/leagues/${leagueId}/rankings`, { params });
    return response.data;
};

const getLeagueRankingHistory = async (leagueId, userId) => {
	const params = { userId };
	// Posíláme IANA zónu prohlížeče, aby backend definoval hranice hracího dne ve stejné
	// zóně, podle které frontend zápasy do dnů grupuje (stejně jako getLeagueRankings).
	const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
	if (tz) {
		params.zone = tz;
	}
	const response = await axiosInstance.get(`/leagues/${leagueId}/rankings/history`, { params });
	return response.data;
};

const joinLeague = async (leagueId) => {
	const response = await axiosInstance.post(`/leagues/${leagueId}/join`, {},
		{
			headers: {
				'Content-Type': 'application/json',
			},
		});
	return response.data;
};

const leaveLeague = async (leagueId) => {
	const response = await axiosInstance.post(`/leagues/${leagueId}/leave`, {},
		{
			headers: {
				'Content-Type': 'application/json',
			},
		});
	return response.data;
};

const removeUserFromLeague = async (leagueId, userId) => {
	const response = await axiosInstance.delete(`/leagues/${leagueId}/players/${userId}`);
	return response.data;
};

export default {
	createLeague,
	getAllLeagues,
	getPublicLeagues,
	getMyLeagues,
	deleteLeague,
	updateLeague,
	getLeagueById,
	getLeagueRankings,
	getLeagueRankingHistory,
	joinLeague,
	leaveLeague,
	removeUserFromLeague
};